import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cards-reusable',
  standalone: true,
  imports: [],
  templateUrl: './cards-reusable.html',
  styleUrl: './cards-reusable.css',
  // `title` is an @Input, but a literal `title="..."` also reflects onto the
  // host as a native HTML attribute, giving the whole card a browser tooltip
  // that leaks over any child (e.g. truncated text). Strip it from the host.
  host: { '[attr.title]': 'null' },
})
export class CardsReusable {
  @Input() title = 'Card title';
  @Input() subtitle = '';
  @Input() badge = '';
  @Input() actionLabel = '';
  @Input() extraClasses = '';

  @Output() action = new EventEmitter<void>();

  onAction(): void {
    this.action.emit();
  }
}
